/* global $, Tracker */

;(function($) {
    'use strict';
    $(document).on('ready',function () {
        var $root = $('.top-up__form');
        $root.each(function (index, element) {

            var $root = $(element);
            var $select = $root.find('.top-up__pay-with');
            var $repeatedPaymentSwitcher = $root.find('.top-up__repeat-payment-switcher');
            var $repeatedPaymentForm = $root.find('.top-up__repeat-payment-form');

            var selectChanged = function () {
                var $option = $select.find(':selected');
                var selected = $option.val();

                $root.find('.top-up__pay-with_block').addClass('top-up__pay-with_hidden');
                $root.find('.top-up__icon i').removeClass().addClass('b-icon-payment-' + selected);

                var $cardsToShow = $root.find('.top-up__pay-with_block-' + selected);

                $cardsToShow.removeClass('top-up__pay-with_hidden');

                var action = $option.data('action') == 'yandex' ? $root.data('actionYandex') : $root.data('actionNevesta');
                if (action) {
                    $root.attr('action', action);
                }
            };

            var repeatedPaymentChange = function (isInit) {
                if ($repeatedPaymentSwitcher.is(':checked')) {
                    $repeatedPaymentForm.removeClass('top-up__repeat-payment-form_hidden');
                    $repeatedPaymentForm.find('.top-up__repeat-payment-money').trigger('change');
                } else {
                    $repeatedPaymentForm.addClass('top-up__repeat-payment-form_hidden');
                }
            };

            var insertValueIntoButton = function (event) {
                var $balanceValue = $root.find('.balance-value');
                var $input = $('.top-up__money-input', $root);

                if ($input.length > 0) {
                    var object = _.find(event.formData, function (obj){
                        return obj.name === $input.attr('name');
                    });
                    if ($balanceValue.length > 0) {
                        $balanceValue.text(object.value);
                    }
                }
            };


            if ($root.is('.form-parsley')) {
                $(document).on('Parsley::FormSuccess', insertValueIntoButton);
            }

            var $error = $root.find('.top-up__error');

            $select.on('change', function () {
                selectChanged();
            });

            if ($repeatedPaymentSwitcher.length) {
                $repeatedPaymentSwitcher.on('change', function (e) {
                    repeatedPaymentChange();
                });
            }

            var $submitButton = $root.find('[type=submit]');

            $submitButton.on('click', function (event) {
                event.preventDefault();

                $submitButton.addClass('top-up__pay-button_process');

                var $receiptField = $root.find('[name=ym_merchant_receipt]');
                var $sumInput = $('.top-up__money-input', $root);

                try {
                    var receipt_value = JSON.parse($receiptField.val());
                    receipt_value.items[0]['price']['amount'] = parseFloat($sumInput.val());
                    $receiptField.val(JSON.stringify(receipt_value));
                }
                catch (e) {
                    $submitButton.removeClass('top-up__pay-button_process');
                    window.Toasts.pushToast('Произошла ошибка проведения платежа. Если ошибка повторится, пожалуйста, обратитесь к администрации сайта.', 'fail');
                    throw new Error(e);
                    return false;
                }

                var $option = $select.find(':selected');

                if ('undefined' !== typeof window.Tracker) {
                    window.Tracker.pushEvent(
                        {
                            category : $option.data('eventCategory'),
                            action   : $option.data('eventAction'),
                            label    : $option.data('eventLabel')
                        }
                    );
                }

                if ($repeatedPaymentSwitcher.is(':checked')) {
                    if ('undefined' !== typeof window.Tracker) {
                        window.Tracker.pushEvent(
                            {
                                category : $option.data('eventCategory'),
                                action   : $option.data('eventAction'),
                                label    : $option.data('eventLabel')
                            }
                        );
                    }
                }

                $
                .post($root.data('action-notify'), $root.serialize())
                .always(function () {
                    $root.submit();
                });
            });

            if ($select.length) {
                selectChanged();
            }
            if ($repeatedPaymentSwitcher.length) {
                repeatedPaymentChange();
            }

            if ($root.hasClass('form-parsley_deffered')) {
                $root.addClass('form-parsley').removeClass('form-parsley_deffered');
                $(document).trigger('Parsley::Init');
                $(document).on('Parsley::FormSuccess', insertValueIntoButton);
            }
        });
    });
})(jQuery);
